export default __webpack_public_path__ + "static/media/datavis.e622abc7.jpg";